import { Injectable, effect, signal } from '@angular/core';
import { IAppEnvironment } from '../../api/proxy/app-environment/app-environment-models';
import { environment } from '../../../environments/default/environment';
import { OnboardingService } from '@/services/onboarding-service/onboarding.service';
import { BehaviorSubject } from 'rxjs';

interface LayoutState {
  showPatientProfile: any;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  state: LayoutState = {
    showPatientProfile: signal(false),
  };

  public logoUri: string = '';
  private _IAppEnvironment: IAppEnvironment | null = null;

 
  public readonly isLogoLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private _onboardingService: OnboardingService) {}

  public EnvironmentConfig(): IAppEnvironment {
    if (!this._IAppEnvironment) throw new Error('Environment not loaded');
    return this._IAppEnvironment;
  }


  public async GetLogo(): Promise<void> {
    this.isLogoLoading$.next(true); 
    await new Promise(resolve => setTimeout(resolve, 500));

    try {
      const hostId = await this._onboardingService.GetHostConfig();

      if (hostId) {
        this.logoUri = `${environment.organizationBaseUrl}/Anonymous/${hostId}/Image`;
      } else {
        this.logoUri = '';
      }
    } catch (error) {
      console.error('Failed to get the logo:', error);
      this.logoUri = '';
    } finally {
          await new Promise(resolve => setTimeout(resolve, 1000));
      this.isLogoLoading$.next(false); 
    }
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return !this.isDesktop();
  }
}
